import { render, staticRenderFns } from "./ShiftEditor.vue?vue&type=template&id=d52b150c&scoped=true&lang=pug&"
import script from "./ShiftEditor.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52b150c",
  null
  
)

export default component.exports